import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useUser } from "~/Context/userContext";
import { getArtistIsFavorite, setArtistFavorite } from "~/api/getArtist";

import axios from "react-axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";

import styled from "styled-components";

export const Wrapper = styled.span`
  font-size: 16px;
  margin: 4px 0 8px 0;
  div {
    background-color: #efefef;
    /* border: 1px solid #b7b3b3; */
    border-radius: 6px;
    overflow: auto;
    padding: 0px 18px 0px 4px;
    line-height: 32px;
    max-width: 320px;
    margin: 0 auto;
    display: inline-block;
    font-size: 16px;
  }
  button {
    border: 0;
    padding: 4px 8px;
    margin-right: 2px;
    background-color: transparent;
  }
  .star-icon {
    /* float: left; */
    margin-top: 2px;
    margin-right: 7px;
    font-size: 16px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const ArtistAddFavorite = (props) => {
  const { artistId = 0, artistName = "" } = props; // default Zero, artist id is undefined , not in database yet
  const { state: userState, dispatch } = useUser();

  const [isFavorite, setIsFavorite] = useState(false);
  const [artistFavId, setArtistFavId] = useState(artistId);

  useEffect(() => {
    getArtistIsFavorite(axios, artistFavId).then((result) => setIsFavorite(result.data.liked));
  }, []);

  const setFavorite = async () => {
    if (!userState.loggedin) {
      localStorage.setItem("login_artist_fav", JSON.stringify({ artistFavId, artistName }));
      dispatch({ type: "signin_open" });
      // faked since we cant set these values after login/register
      setIsFavorite(true);
      return;
    }
    setArtistFavorite(axios, artistFavId, artistName).then((result) => {
      setIsFavorite(!isFavorite);
      setArtistFavId(result.data.artistId);
    });
  };

  return (
    <span>
      <Wrapper>
        <div onClick={setFavorite}>
          <button>
            <FontAwesomeIcon className="star-icon" icon={isFavorite ? faStar : faStarOutline} />
          </button>
          Favorite
        </div>
      </Wrapper>
    </span>
  );
};

ArtistAddFavorite.propTypes = {
  artistId: PropTypes.number,
};

export default ArtistAddFavorite;
